<template id="linkDealModalDrawer">
		<el-drawer
			:visible.sync="modalInfo.isShow"
      size="920px"
			@close="closeDrawer"
    >
		<div slot="title" class="detail-header" v-if="modalInfo.isShow">
     	<div class="productInfo">
			 	<img :src="modalInfo.row.picurl" alt="">
			 	<div class="info">
				 	<p class="itemtitle">
						<el-link type="primary" :href="modalInfo.row.itemlink" :underline="false" target="_blank">{{modalInfo.row.itemtitle || modalInfo.row.itemlink}}</el-link>
					</p>
					<div class="productName">
						<h3 class="deal-name">
							<span>{{modalInfo.row.shopname}}</span>
							<Shopname :platform="modalInfo.row.platform" />
							<ShopType :shoptype="modalInfo.row.shoptype"/>
						</h3>
						<span class="wangwang">{{modalInfo.row.wangwang}}</span>
						<el-button size="mini" @click="downLoadDataClick">下载数据</el-button>
					</div>
			 	</div>
    </div>
		 	</div>
		<div class="content" style="margin-bottom: 50px;" v-if="modalInfo.isShow">
			<!-- 多sku信息 -->
			<div class="tag-group" v-if="linkSummaryDetail.obj && linkSummaryDetail.obj.length>0 && linkSummaryDetail.obj[0].sku_title">
				<span class="tag-group_title">SKU信息</span>
				<div :class="['tag-group_wrap',isMore?'heightauto':'']">
					<el-tag v-for="(item,i) in linkSummaryDetail.obj"  :class="skuid == item.sku_id ? 'active' : ''" :key="i" type="info" @click="searchTable(item)" effect="plain" size="medium">
						{{ item.sku_title.length>75?item.sku_title.slice(0,75)+'...': item.sku_title}}
					</el-tag>
				</div>
				<span class="is-more-btn" @click="isMore = !isMore">
					{{isMore?'收起':'展开'}}
					<i :class="isMore?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
				</span>
			</div>
			<!-- 表格 -->
			<el-table
				class="detail-table"
				header-row-class-name="data-table-header"
				:data="linkSummaryDetail.content"
				tooltip-effect="dark"
				style="width: 100%"
				>
					<el-table-column label="序号" type="index"></el-table-column>
					<el-table-column label="sku信息" prop="productname" width="240">
						<template slot-scope="scope">
							<div @click.stop style="position:relative;">
								<span class="lowTag" v-if="scope.row.skuislowprice">低</span>
								<img :src="scope.row.picurl" alt="" style="display:inline-block;width:50px;vertical-align: top;margin: 0 0 0 20px;" v-if="scope.row.picurl">
								<el-popover trigger="hover" placement="top" popper-class="cell-pover">
									<p><span>sku信息:</span> <span>{{ scope.row.sku_title }}</span></p>
									<p><span>对应产品:</span> <span> {{ scope.row.productname }}</span></p>
									<div slot="reference" class="cell-wrap">
										<p>{{scope.row.sku_title}}</p>
										<p>{{scope.row.productname}}</p>
									</div>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="价格" width="130">
						<template slot-scope="scope">
							<p>标价:{{scope.row.price_sign ? `￥${scope.row.price_sign}`:'--'}}</p>
							<p>到手价:{{scope.row.price_header ? `￥${scope.row.price_header}`:'--'}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="price_check" label="限价标准" width="80">
						<template slot-scope="scope">
							<span>{{scope.row.price_check ? `￥${scope.row.price_check}`:''}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="item_coupons" width="140" label="优惠信息">
						<template slot-scope="scope">
							<div class="tag-wrap" v-if="scope.row.item_coupons">
								<span class="tag orange" v-for="(item,i) in scope.row.item_coupons.split(';')" :key="i">{{item}}</span>
							</div>
							<div class="tag-wrap" v-if="scope.row.item_activities">
								<span class="tag orangered" v-for="(item,i) in scope.row.item_activities.split(';')" :key="i">{{item}}</span>
							</div>
							<div class="tag-wrap" v-if="scope.row.item_sale">
								<span class="tag purple" v-for="(item,i) in scope.row.item_sale.split(';')" :key="i">{{item}}</span>
							</div>
							<div class="tag-wrap" v-if="scope.row.item_info">
								<span class="tag orange" v-for="(item,i) in scope.row.item_info.split(';')" :key="i">{{item}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="monitortype" width="80" label="监控类型">
						<template slot-scope="scope">
							<span>{{ scope.row.plantype == 0 ? '标价':'到手价' }}</span>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="sku_status" width="50" label="状态">
						<template slot-scope="scope">
								<span :style="scope.row.sku_status == '上架' ? {color:'#52c41a'}:scope.row.sku_status == '下架'?{color:'red'}:''">{{ scope.row.sku_status}}</span>
						</template>
					</el-table-column> -->
						<el-table-column prop="monitor_time" width="100" label="监控时间">
						<template slot-scope="scope">
							<span>{{ scope.row.monitor_time|fullTime }}</span>
						</template>
					</el-table-column>
					<el-table-column label="违规快照">
						<template slot-scope="scope">
							<el-link  type="primary" 	:underline="false" @click.stop="" v-if="scope.row.islowprice_jt">
								查看快照
								<viewer>
									<img :src="scope.row.islowprice_jt" style="width:60px;height:30px;opacity: 0;position: absolute;top: 0;">
								</viewer>
							</el-link>
						</template>
					</el-table-column>
			</el-table>
			<Pagination
				v-if="linkSummaryDetail.totalElements"
				class="pagination"
				:total="linkSummaryDetail.totalElements"
				:pagination="query"
				@onChange="load"
			/>
		</div>
	</el-drawer>
</template>
<script>
import Shopname from "@/components/shopname/Shopname.vue";
import ShopType from "@/components/shopType";
import Pagination from "@/components/pagination/pagination";

import {mapState,mapActions} from 'vuex';
export default {
	components: {Shopname,ShopType,Pagination},
    name:'detailModel',
    props:{
			modalInfo:{
					type:Object,
					default:() =>{
						return{
							isShow:false
						}
					}
			}
		},
		computed:{
			...mapState({
				linkSummaryDetail:tate => state.linkSummary.linkSummaryDetail
			})
		},
    data(){
			return {
				isMore:false,
				skuid:'',
				query: {
					size: 10,
					current: 1,
				},
				detailInfo:{
					shoptype:'1'
				},
				skuClick:false
		}
		},
		computed: {
			...mapState({ linkSummaryDetail: state => state.linkSummary.linkSummaryDetail}),
		},
		methods:{
			...mapActions(["reqLinkSummaryDetail"]),
			closeDrawer(){
				this.query = {
					size: 10,
					current: 1
				}
			},
			getParams() {
				let params = {
					pageNo: this.query.current,
					pageSize: this.query.size,
					itemid:this.modalInfo.row.itemid,
					skuid:this.linkSummaryDetail.skuID
				};
				return params;
			},
			load() {
				let params = this.getParams();
				params.skuid = this.skuid;
				this.reqLinkSummaryDetail(params);
			},
			getParamUrl(data) {
				let url = "";
				for (var k in data) {
					let value = data[k] && data[k] !== undefined ? data[k] : "";
					url += `&${k}=${encodeURIComponent(value)}`;
				}
				return url ? url.substring(1) : "";
			},
			// 下载数据
			downLoadDataClick() {
				let query = {
					itemid:this.modalInfo.row.itemid,
					itemtitle:this.modalInfo.row.itemtitle,
					platform:this.modalInfo.row.platform,
					shopname:this.modalInfo.row.shopname,
					shoptype:this.modalInfo.row.shoptype,
					skuid:this.modalInfo.row.skuid
				};
				let params = this.getParamUrl(query);
				let url = `/hcm/hcmNewMonitorProduct/DownloadSkuDetailPage?${params}`;
				window.open(url);
			},
			// 多sku筛选
			searchTable(item){
				this.skuClick = !this.skuClick;
				this.skuid = item.sku_id;
				if(!this.skuClick){
					this.skuid = null;
				}
				let params = this.getParams();
				let query = {
					...params,
					skuid:this.skuid
				}
				this.reqLinkSummaryDetail(query);
			}

		}
}
</script>
<style lang="scss">
#linkDealModalDrawer {
	.el-drawer {
		.el-drawer__header{
			margin: 0;
			padding: 10px 15px!important;
		}
		.el-drawer__body{
			padding: 10px!important;
	    height: auto;
	    overflow: auto;
		}
		.el-icon-close{
			display: block!important;
	    position: absolute;
	    top: 10px;
	    right: 20px;
		}
	}
	.detail-header {
		h3,h4,p{
			margin: 0;
		}
		.productInfo{
			display: inline-block;
			img{
				width: 66px;
	    	vertical-align: bottom;
			}
			.info{
				display: inline-block;
				width: calc(100% - 76px);
				margin-left: 10px;
			}
		}
		.productName{
			line-height: 20px;
			font-weight: normal;
			font-size: 14px;
			.deal-name{
				display: inline-block;
				margin: 10px 0 0 0;
	    	font-weight: 500;
				.el-image{
					vertical-align:text-bottom;
					margin: 0 0 0 10px;
					img{
						width: 18px;
						height: 18px;
					}
				}
				.shoptype{
					font-weight: normal;
					vertical-align: unset;
					height: 18px;
					font-size: 12px;
				}
			}
			.wangwang{
				padding: 0 0 0 10px;
	    	color: #999;
			}
			.el-button{
				position: absolute;
				right: 20px;
			}
		}
	}
	.detail-table {
		.lowTag{
			position: absolute;
	    top: 17px;
	    left: 0px;
		}
		&.el-table th>.cell{
			padding: 0 0 0 4px;
		}
		.cell-wrap{
			display: inline-block;
	    width: calc(100% - 75px);
	    margin-left: 5px;
			p{
				margin: 0;
				overflow: hidden;
				&:nth-of-type(2){
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				}
				&:nth-of-type(1){
					white-space: nowrap;
					text-overflow: ellipsis;
					color: #409eff;
				}
			}
		}
		td{
			padding: 0!important;
		}
	}
	.tag-group {
		&_title{
			vertical-align: top;
		}
		&_wrap{
			display: inline-block;
			width: calc(100% - 100px);
			height: 38px;
	    overflow: hidden;
			&.heightauto{
				height: auto;
			}
		}
	 .el-tag {
	    margin-left: 10px;
			margin-bottom: 10px;
			cursor: pointer;
			&:hover{
				color: #409EFF;
				border-color: #c6e2ff;
				background-color: #ecf5ff;
			}
			&.active{
				color: #409EFF;
	    	border-color: #409EFF;
			}
		}
		.is-more-btn{
			position: absolute;
	    right: 30px;
	    color: #409eff;
	    cursor: pointer;
		}
	}
	.tag {
		display: inline-block;
		margin-bottom: 4px;
		color: #fff;
		// min-height: 18px;
		font-size: 12px;
		line-height: 18px;
		text-align: left;
		padding: 0 7px;
		&.orange {
			background: #ffb938;
		}
		&.orangered {
			background: url('https://hawksights.obs.cn-east-2.myhuaweicloud.com/ceshi/1572488951496.png');
		}
		&.purple {
			border: 1px solid #a43ca4;
			color: #a43ca4;
		}
	}
	.cell-pover{
		max-width: 300px!important;
		p{
			display: flex;
			margin: 6px 0;
			span:nth-of-type(1){
				width: 60px;
			}
			span:nth-of-type(2){
				width: calc(100% - 60px);
			}
		}
	}
}
</style>
